// import Styles from './styles';
import  './styles.css';
import LogoSpinner from "@/modules/Shared/components/LogoSpinner/LogoSpinner";
// import Spinner from '../Spinner/Spinner';

const RouterFallback = ({ text }) => {
  return (
    // <Styles.Wrapper>
      <div className={"RouterFallback-wrapper"}>
      <LogoSpinner />
      {/*<p>{text ?? 'Getting the view content'}</p>*/}
      </div>
    // </Styles.Wrapper>
  );
};

export default RouterFallback;
